module.exports = __webpack_public_path__ + "img/comment_light.ae8f2b1b.svg";